import React from "react";
import useCompanyTerms from "utils/getCompanyInfo";
import { useCheckout } from "context/CheckoutContext";
import { useClient } from "ClientContext";

interface TermsPopupProps {
  internalId: string;
  onClose: () => void;
  companyId?: string; // Add company ID prop
}

const TermsPopup: React.FC<TermsPopupProps> = ({internalId, onClose, companyId }) => {
  const {terms} =useCompanyTerms();
  const companyTerms = terms;



  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white dark:bg-neutral-800 rounded-lg p-6 max-w-3xl w-full overflow-y-auto max-h-[80vh]">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-neutral-800 dark:text-neutral-200">
            Terms & Conditions
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400"
          >
            Close
          </button>
        </div>

        {/* Terms & Conditions Content */}
        <div className="text-sm text-neutral-600 dark:text-neutral-400 space-y-4">
          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">Welcome</h3>
          <p>
            Welcome to {companyTerms.companyName} rental property booking platform. These Terms and Conditions 
            outline the rules and regulations for all reservations. By confirming a booking, 
            You agree to comply with these Terms.
          </p>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">Definitions</h3>
          <p><strong>The Company:</strong> Referred to as "We", "Us", or "Our", responsible for managing this rental platform.</p>
          <p><strong>Property:</strong> Any accommodation listed on our platform available for booking.</p>
          <p><strong>Guest (You):</strong> The individual making a booking, or the person on whose behalf the booking is made.</p>
          <p><strong>Service:</strong> The online booking system and related services offered through our website.</p>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">Acknowledgment</h3>
          <p>
            By making a booking, You acknowledge that these Terms form a binding agreement between You and the Company. 
            You also confirm that You have reviewed our <strong>Privacy Policy</strong>, which explains how we process 
            personal data in accordance with the General Data Protection Regulation (GDPR).
          </p>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">GDPR & Data Protection</h3>
          <p>
            We collect and process personal data strictly for the purpose of managing bookings, guest communication, 
            and fulfilling legal requirements. In line with GDPR, You have the right to access, correct, or request deletion 
            of Your data, as well as the right to object to processing or request portability of Your information. 
            We will never share Your details with third parties except where necessary to provide the Service or 
            where required by law.
          </p>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">House Rules</h3>
          <p className=" whitespace-pre-line">
            {companyTerms.houseRules}
            Guests agree to respect the property, neighbors, and local community. Any damage, misconduct, or breach of rules 
            may result in termination of the stay without refund and possible liability for damages.
          </p>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">Payment Policy</h3>
          <p>{companyTerms.paymentPolicy}</p>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">Cancellation Policy</h3>
          <ul className="list-disc pl-5">
            {companyTerms.cancellationPolicy.map((policy, index) => (
              <li key={index}>{policy}</li>
            ))}
          </ul>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">Check-in & Check-out</h3>
          <p>
            <strong>Check-in time:</strong> {companyTerms.checkInTime}<br />
            <strong>Check-out time:</strong> {companyTerms.checkOutTime}<br />
            Early check-in or late check-out may be available upon request but is not guaranteed.
          </p>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">Limitation of Liability</h3>
          <p>
            The Company shall not be held liable for any accidents, injuries, loss, or damage that occurs during the Guest's stay. 
            Guests are responsible for ensuring they have appropriate travel and personal insurance.
          </p>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">Termination</h3>
          <p>
            The Company reserves the right to cancel or terminate bookings in cases of fraud, breach of these Terms, 
            or misuse of the property. In such cases, refunds are at the Company's discretion.
          </p>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">Changes to Terms</h3>
          <p>
            We may update these Terms from time to time. If significant changes are made, Guests will be notified prior 
            to their booking taking effect. Continued use of the Service constitutes acceptance of the revised Terms.
          </p>

          <h3 className="font-semibold text-neutral-800 dark:text-neutral-200">Contact Us</h3>
          <p>
            If You have any questions regarding these Terms or Your booking, please contact us at:<br />
            <strong>Email:</strong> {companyTerms.contactEmail}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPopup;